




import React, { useState, useRef, useEffect } from 'react';
import html2pdf from 'html2pdf.js';
import { useSelector } from 'react-redux';
import { X, History } from 'lucide-react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import signature from '../../assets/whatsapp.jpg';

const PermanentLetter = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [message, setMessage] = useState(` 


Date: 15TH November, 2025.


ESSENTIAL.NG
No 7, Kaffi Street,
Alausa Ikeja,	
Lagos
08154556666

To Mr. IFEANYI BRIGHT DEREEK

LETTER OF EMPLOYMENT

Following your recent application for employment and subsequent interview and your one week training you undergone with the company, management is pleased to offer you an employment on a contract basis as a HOUSE KEEPPER You will be on a probationary period of six months from the date of this letter of employment. This employment may be confirmed or terminated during the period of probation for non-performance.

Note that your total monthly remuneration will be as follows: 
1. Your monthly basic salary is N60,000
2. 5% tax will be deducted from your monthly salary which will be remitted to Lagos State Government Tax Office.

Please Note the following rules and regulation of the company and the terms of your employment;
1. The Salary is subject to review within three, six or twelve month after the resumption of duties. {Subject to performance without any query or disciplinary action} 
2. You may be ask to go to any of the Company's branches in Lagos, Ibadan or any other States at any point in time. 
3. You are to abide by the dress code regulations at all time. The dress code is  white shirt and black trouser with black shoes and black belt, black tie/self. Failure to comply shall attract a fine of N5,000 for each violation, while the third violation shall result in dismissal. 
4. All the staff must be clean always. 
5. You will be penalised or dismissed without pay in the event of theft, and you will be handed over to the police for prosecution. In the cases of conspiracy to commit fraud, negligence, dereliction of duty or failure to abide by any of the rules and regulations herein stated and  regulations as pertaining to your department as provided or often provided by the company, the penalty will be a deduction of a specific amount of money as shall be determined by management from your salary. 
6. You are to give two weeks notice in writing of your intention to terminate your employment with the company or two weeks salary in lieu of notice. You shall forfeit your salary for the said month and all your entitlement in your failure to give the said two weeks notice. 
7. Salary is paid every 3rd of the following month. 
8. Lateness to work attract N300. 00 each time, while 3 times lateness in a month attract N5,000 penalty. 
9. You are not to use your mobile phone while on duty. If caught, the penalty is N5,000 or possible dismissal.. 
10. Failure to complete any relevant registration: Petty cash, Voucher, Movement slip, Reception call log, Guest check in and out form, Guest receipt (Bar or Restaurant), Housekeeping authorization, Generator usage up/down time, fuel purchase and usage, plumbing, Electrical and Laundry work done, Attendance sign in /out register will attract N5,000 plus suspension or dismissal from work. 
11. Daily Activities form must be updated every half an hour through your working shift to prove your working activities. Otherwise penalty applies from N1-2,000. 
12. Do not leave your working position without any approval from your superior or head of office and also fill the staff attendance and movement register. Failure to comply N5,000 penalty. 
13. Be polite to all customers and management. Always use please and thank you Sir/ Ma, Bowing down in form of respect and humble, smiling. Failure may attract N1-2,000 penalty. 
14. Always work as a team. Quarrelling, Fighting or Arguing while on duty is prohibited. Sleeping on duty attracts N5,000 penalty and suspension or possibly dismissal please take note. 
15. Always channel guest complaint and feed back to the management. Report any suspicious movement to the security and the management. 
16. If you are suspended you are expected to resume back to work; even If you want to quit you must resume and tender your two weeks resignation letter. Failure to resume after suspension will be forfeited your salary. 
17. Solemnly accept to abide by the organization policies, condition and procedures on disciplinary measure for the offences of theft, fraud obtaining of money or any form item through tricks, magnitude, and negligence of duty, lateness and absence from work without permission. 
18. In addition to your employment with the company, whatever dispute, discipline actions, terms and conditions, employees shall be dealt with strictly and only by the Human Resource or Administration Manager. 
19. The management are not liable for whatever decision and action carried out with the company terms and condition of employment against you as agreed in this employment contract. The company is not responsible for any accident cause to any employee by the negligence of any employee with regards to his or her responsibilities. 
20. I agree that I will abide with the six to twelve months period confirmation as a full staff. 

I have read and understand all the terms and condition and I am not under duress/ pressure to sign this undertaking. 
I accept these terms and conditions of my employment.

We hope you will give your best to the organization.
Please accept our Congratulations. 


FOR: ESSENTIAL LTD                                  NAME AND SIGNATURE OF EMPLOYEE









`);
  const [isWhatsAppModalOpen, setIsWhatsAppModalOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('+234');
  const [emailAddress, setEmailAddress] = useState('');
  const [whatsappRecipients, setWhatsappRecipients] = useState([]);
  const [emailRecipients, setEmailRecipients] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState(new Set());
  const [selectedEmails, setSelectedEmails] = useState(new Set());
  const [selectAllWhatsapp, setSelectAllWhatsapp] = useState(false);
  const [selectAllEmails, setSelectAllEmails] = useState(false);
  const [sentLetters, setSentLetters] = useState([]);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const contentRef = useRef(null);

  // Fetch sent letters on component mount
  useEffect(() => {
    const fetchSentLetters = async () => {
      if (!currentUser?.userId) return;
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}sent-letters`, {
          params: { userId: currentUser.userId },
        });
        if (response.data.success) {
          setSentLetters(response.data.data);
        } else {
          toast.error('Failed to fetch sent letters.');
        }
      } catch (error) {
        toast.error('Error fetching sent letters: ' + error.message);
      }
    };
    fetchSentLetters();
  }, [currentUser]);

  // Save letter to database
  const saveLetterToDatabase = async (recipient, type) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}sent-letters`, {
        recipient,
        type,
        letterContent: message,
        userId: currentUser?.userId || 'anonymous',
        timestamp: new Date().toISOString(),
      });
      if (response.data.success) {
        setSentLetters((prev) => [
          ...prev,
          {
            id: response.data.id,
            recipient,
            type,
            letterContent: message,
            timestamp: new Date().toISOString(),
          },
        ]);
        toast.success(`Letter saved to ${type} recipient: ${recipient}`);
      } else {
        toast.error(`Failed to save ${type} letter.`);
      }
    } catch (error) {
      toast.error(`Error saving ${type} letter: ${error.message}`);
    }
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleDownload = () => {
    if (!contentRef.current) {
      toast.error('Error: Content is not available for download.');
      return;
    }
    const element = contentRef.current;
    const opt = {
      margin: 1,
      filename: 'Employment_Offer.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    };
    html2pdf().set(opt).from(element).save();
  };

  const handlePrint = () => {
    if (!contentRef.current) {
      toast.error('Error: Nothing to print. Please try again.');
      return;
    }
    window.print();
  };

  const addWhatsappRecipient = () => {
    if (!whatsappNumber || whatsappNumber === '+234') {
      toast.error('Please enter a valid WhatsApp number.');
      return;
    }
    const cleaned = whatsappNumber.replace(/\D/g, '');
    if (cleaned.length < 10) {
      toast.error('Invalid number format.');
      return;
    }
    if (!whatsappRecipients.includes(whatsappNumber)) {
      setWhatsappRecipients([...whatsappRecipients, whatsappNumber]);
    }
    setWhatsappNumber('+234');
  };

  const removeWhatsappRecipient = (num) => {
    setWhatsappRecipients(whatsappRecipients.filter((r) => r !== num));
    setSelectedWhatsapp((prev) => {
      const newSet = new Set(prev);
      newSet.delete(num);
      return newSet;
    });
  };

  const toggleSelectWhatsapp = (num) => {
    setSelectedWhatsapp((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(num)) {
        newSet.delete(num);
      } else {
        newSet.add(num);
      }
      setSelectAllWhatsapp(newSet.size === whatsappRecipients.length && whatsappRecipients.length > 0);
      return newSet;
    });
  };

  const toggleSelectAllWhatsapp = () => {
    if (selectAllWhatsapp) {
      setSelectedWhatsapp(new Set());
    } else {
      setSelectedWhatsapp(new Set(whatsappRecipients));
    }
    setSelectAllWhatsapp(!selectAllWhatsapp);
  };

  const addEmailRecipient = () => {
    if (!emailAddress || !emailAddress.includes('@')) {
      toast.error('Please enter a valid email address.');
      return;
    }
    if (!emailRecipients.includes(emailAddress)) {
      setEmailRecipients([...emailRecipients, emailAddress]);
    }
    setEmailAddress('');
  };

  const removeEmailRecipient = (email) => {
    setEmailRecipients(emailRecipients.filter((r) => r !== email));
    setSelectedEmails((prev) => {
      const newSet = new Set(prev);
      newSet.delete(email);
      return newSet;
    });
  };

  const toggleSelectEmail = (email) => {
    setSelectedEmails((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(email)) {
        newSet.delete(email);
      } else {
        newSet.add(email);
      }
      setSelectAllEmails(newSet.size === emailRecipients.length && emailRecipients.length > 0);
      return newSet;
    });
  };

  const toggleSelectAllEmails = () => {
    if (selectAllEmails) {
      setSelectedEmails(new Set());
    } else {
      setSelectedEmails(new Set(emailRecipients));
    }
    setSelectAllEmails(!selectAllEmails);
  };

  const handleApproveWhatsApp = () => {
    if (selectedWhatsapp.size === 0) {
      toast.error('Please select at least one WhatsApp recipient.');
      return;
    }
    toast('Please download the PDF first and attach it manually in WhatsApp after opening the chats.', {
      duration: 6000,
    });
    handleDownload();
    selectedWhatsapp.forEach(async (num) => {
      await saveLetterToDatabase(num, 'whatsapp');
      const cleanedNumber = num.replace(/\D/g, '');
      const encodedMessage = encodeURIComponent('Please find the attached Employment Offer PDF.');
      const whatsappUrl = `https://wa.me/${cleanedNumber}?text=${encodedMessage}`;
      window.open(whatsappUrl, '_blank');
    });
    setIsWhatsAppModalOpen(false);
    setSelectedWhatsapp(new Set());
    setSelectAllWhatsapp(false);
  };

const handleApproveEmail = async () => {
  if (selectedEmails.size === 0) {
    toast.error('Please select at least one email recipient.');
    return;
  }
  if (!contentRef.current) {
    toast.error('Error: Content is not available to send.');
    return;
  }

  setIsSendingEmail(true);

  const opt = {
    margin: 1,
    filename: 'Employment_Offer.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
  };

  try {
    // Generate the PDF once — same content goes to every recipient
    const pdfBase64 = await html2pdf()
      .set(opt)
      .from(contentRef.current)
      .output('datauristring');

    const results = await Promise.allSettled(
      Array.from(selectedEmails).map(async (email) => {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}offer/send-offer-letter`, {
          email,
          pdfBase64,
          message: 'Please find your Letter of Employment attached.',
        });
        if (!res.data.success) throw new Error(res.data.message || 'Send failed');
        await saveLetterToDatabase(email, 'email');
        return email;
      })
    );

    const succeeded = results.filter((r) => r.status === 'fulfilled').map((r) => r.value);
    const failed = results.filter((r) => r.status === 'rejected');

    if (succeeded.length > 0) {
      toast.success(`Letter sent to: ${succeeded.join(', ')}`);
    }
    if (failed.length > 0) {
      toast.error(`Failed to send to ${failed.length} recipient(s). Check console for details.`);
      failed.forEach((f) => console.error(f.reason));
    }

    setIsEmailModalOpen(false);
    setSelectedEmails(new Set());
    setSelectAllEmails(false);
  } catch (err) {
    toast.error('Failed to send letter: ' + err.message);
    console.error(err);
  } finally {
    setIsSendingEmail(false);
  }
};

  const handleViewLetter = (letter) => {
    setSelectedLetter(letter);
  };

  const closeHistoryModal = () => {
    setIsHistoryModalOpen(false);
    setSelectedLetter(null);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <Toaster position="top-right" />
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Edit Employment Offer</h2>
        <textarea
          value={message}
          onChange={handleMessageChange}
          className="w-full p-4 border border-gray-300 rounded mb-4 h-64 resize-y"
          placeholder="Edit the employment offer message here..."
        />
        <div className="flex flex-wrap gap-4 mb-6">
          <button
            onClick={handleDownload}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
          >
            Download PDF
          </button>
          <button
            onClick={handlePrint}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
          >
            Print
          </button>
          <button
            onClick={() => setIsWhatsAppModalOpen(true)}
            className="bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 px-4 rounded"
          >
            Send to WhatsApp
          </button>
          <button
            onClick={() => setIsEmailModalOpen(true)}
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded"
          >
            Send to Email
          </button>
          <button
            onClick={() => setIsHistoryModalOpen(true)}
            className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded"
          >
            View Sent Letters
          </button>
        </div>
        <div ref={contentRef} className="prose max-w-none">
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900 uppercase tracking-wide">ESSENTIAL.NG</h1>
            <p className="text-sm font-medium text-gray-700">No 7, Kaffi Street, Alausa Ikeja, Lagos</p>
            <p className="text-sm font-medium text-gray-700">08154556666</p>
            <h2 className="text-xl font-semibold text-gray-800 mt-4 border-b-2 border-gray-900 pb-1 inline-block">
              Permanent Letter of Employment
            </h2>
          </div>
          <p className="whitespace-pre-wrap">{message}</p>
          <div className="mt-8 flex items-end">
            <div>
              <img src={signature} alt="HR Signature" className="h-36 w-66 w-auto" />
              <p className="text-sm text-gray-700">(Human Resources)</p>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Modal */}
      {isWhatsAppModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md max-h-screen overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Manage WhatsApp Recipients</h3>
              <button onClick={() => setIsWhatsAppModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="flex gap-2 mb-4">
              <input
                type="tel"
                value={whatsappNumber}
                onChange={(e) => setWhatsappNumber(e.target.value)}
                className="flex-1 p-2 border border-gray-300 rounded"
                placeholder="+234..."
              />
              <button
                onClick={addWhatsappRecipient}
                className="bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded"
              >
                Add
              </button>
            </div>
            {whatsappRecipients.length > 0 && (
              <>
                <div className="mb-2">
                  <label className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={selectAllWhatsapp}
                      onChange={toggleSelectAllWhatsapp}
                      className="h-4 w-4"
                    />
                    <span className="text-sm font-medium">Select All</span>
                  </label>
                </div>
                <ul className="space-y-2 mb-4 max-h-48 overflow-y-auto">
                  {whatsappRecipients.map((num) => (
                    <li key={num} className="flex items-center justify-between bg-gray-50 p-2 rounded">
                      <label className="flex items-center gap-2 flex-1">
                        <input
                          type="checkbox"
                          checked={selectedWhatsapp.has(num)}
                          onChange={() => toggleSelectWhatsapp(num)}
                          className="h-4 w-4"
                        />
                        <span className="text-sm">{num}</span>
                      </label>
                      <button
                        onClick={() => removeWhatsappRecipient(num)}
                        className="text-red-500 hover:text-red-700 text-sm"
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={handleApproveWhatsApp}
                  className="w-full bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded"
                >
                  Approve & Send to Selected ({selectedWhatsapp.size})
                </button>
              </>
            )}
            {whatsappRecipients.length === 0 && (
              <p className="text-gray-500 text-center mb-4">No recipients added yet.</p>
            )}
            <button
              onClick={() => setIsWhatsAppModalOpen(false)}
              className="w-full mt-2 bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Email Modal */}
      {isEmailModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md max-h-screen overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Manage Email Recipients</h3>
              <button onClick={() => setIsEmailModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="flex gap-2 mb-4">
              <input
                type="email"
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
                className="flex-1 p-2 border border-gray-300 rounded"
                placeholder="example@domain.com"
              />
              <button
                onClick={addEmailRecipient}
                className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded"
              >
                Add
              </button>
            </div>
            {emailRecipients.length > 0 && (
              <>
                <div className="mb-2">
                  <label className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={selectAllEmails}
                      onChange={toggleSelectAllEmails}
                      className="h-4 w-4"
                    />
                    <span className="text-sm font-medium">Select All</span>
                  </label>
                </div>
                <ul className="space-y-2 mb-4 max-h-48 overflow-y-auto">
                  {emailRecipients.map((email) => (
                    <li key={email} className="flex items-center justify-between bg-gray-50 p-2 rounded">
                      <label className="flex items-center gap-2 flex-1">
                        <input
                          type="checkbox"
                          checked={selectedEmails.has(email)}
                          onChange={() => toggleSelectEmail(email)}
                          className="h-4 w-4"
                        />
                        <span className="text-sm">{email}</span>
                      </label>
                      <button
                        onClick={() => removeEmailRecipient(email)}
                        className="text-red-500 hover:text-red-700 text-sm"
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
                <button
  onClick={handleApproveEmail}
  disabled={isSendingEmail}
  className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded disabled:opacity-50"
>
  {isSendingEmail ? 'Sending...' : `Approve & Send to Selected (${selectedEmails.size})`}
</button>
             
              </>
            )}
            {emailRecipients.length === 0 && (
              <p className="text-gray-500 text-center mb-4">No recipients added yet.</p>
            )}
            <button
              onClick={() => setIsEmailModalOpen(false)}
              className="w-full mt-2 bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* History Modal */}
      {isHistoryModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-4xl max-h-screen overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Sent Letters History</h3>
              <button onClick={closeHistoryModal} className="text-gray-500 hover:text-gray-700">
                <X className="h-5 w-5" />
              </button>
            </div>
            {sentLetters.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="max-h-96 overflow-y-auto">
                  <h4 className="text-md font-medium text-gray-700 mb-2">Sent Letters</h4>
                  <ul className="space-y-2">
                    {sentLetters.map((letter) => (
                      <li
                        key={letter.id}
                        className={`p-3 rounded cursor-pointer hover:bg-gray-100 ${
                          selectedLetter?.id === letter.id ? 'bg-gray-200' : 'bg-gray-50'
                        }`}
                        onClick={() => handleViewLetter(letter)}
                      >
                        <p className="text-sm font-medium text-gray-800">
                          {letter.type === 'whatsapp' ? 'WhatsApp' : 'Email'}: {letter.recipient}
                        </p>
                        <p className="text-xs text-gray-500">
                          Sent: {new Date(letter.timestamp).toLocaleString()}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="border-l border-gray-300 pl-4">
                  {selectedLetter ? (
                    <>
                      <h4 className="text-md font-medium text-gray-700 mb-2">Letter Content</h4>
                      <div className="prose max-w-none bg-gray-50 p-4 rounded">
                        <div className="text-center mb-6">
                          <h1 className="text-3xl font-bold text-gray-900 uppercase tracking-wide">
                            ESSENTIAL.NG
                          </h1>
                          <p className="text-sm font-medium text-gray-700">
                            No 7, Kaffi Street, Alausa Ikeja, Lagos
                          </p>
                          <p className="text-sm font-medium text-gray-700">08154556666</p>
                          <h2 className="text-xl font-semibold text-gray-800 mt-4 border-b-2 border-gray-900 pb-1 inline-block">
                            Permanent Letter of Employment
                          </h2>
                        </div>
                        <p className="whitespace-pre-wrap">{selectedLetter.letterContent}</p>
                        <div className="mt-8 flex items-end">
                          <div>
                            <img src={signature} alt="HR Signature" className="h-36 w-auto" />
                            <p className="text-sm text-gray-700">(Human Resources)</p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <p className="text-gray-500 text-center">Select a letter to view its content.</p>
                  )}
                </div>
              </div>
            ) : (
              <p className="text-gray-500 text-center">No sent letters found.</p>
            )}
            <button
              onClick={closeHistoryModal}
              className="w-full mt-4 bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Print Styles */}
      <style jsx global>{`
        @media print {
          body * {
            visibility: hidden;
          }
          div[ref='contentRef'],
          div[ref='contentRef'] * {
            visibility: visible;
          }
          div[ref='contentRef'] {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          button,
          textarea,
          .fixed {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PermanentLetter;